import React, { useState, useEffect } from "react";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import Logo_1 from "../assets/Logo_1.png";
import "./css/Header.css";
import Ticker from "react-ticker";
const Header = () => {
  const { innerWidth: width, innerHeight: height } = window;

  const [sliders, setSliders] = useState([
    "Photowalk Registrations have started",
  ]);
  const [isHover, setIsHover] = useState(false);

  return (
    <header>
      <Navbar
        className={window.location == "/" ? "nav-bg" : ""}
        variant={width < 900 || window.location !== "/" ? "dark" : "light"}
        expand="lg"
        style={{ zIndex: "1" }}
      >
        <Container>
          <Navbar.Brand href="/">
            <img width="60px" src={Logo_1} alt="" />
            <span className="mobile">Thapar Adventure Club</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/AboutUs">About Us</Nav.Link>
              <Nav.Link href="/Team">Our Team</Nav.Link>
              <Nav.Link href="/Gallery">Gallery</Nav.Link>
              {/* <Nav.Link href="#gallerySection">Gallery</Nav.Link> */}
              {/* <NavDropdown title="Iternaries" id="basic-nav-dropdown">
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                  Separated link
                </NavDropdown.Item>
              </NavDropdown> */}
              <Nav.Link href="#footer">Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
